import React from "react";
import styled from "@emotion/styled";

import { Alert as MuiAlert, AlertColor, Snackbar } from "@mui/material";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import { RootState } from "../redux/store";
import { setSnackbarState } from "../redux/slices/main";

function AlertSnackbar() {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state: RootState) => state.main);

  return (
    <Snackbar
      open={state.snackbarOpen}
      autoHideDuration={
        state.snackbarStatus === ("warning" as string) ? null : 3000
      }
      onClose={() => dispatch(setSnackbarState(false))}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <MuiAlert
        onClose={() => dispatch(setSnackbarState(false))}
        severity={state.snackbarStatus as AlertColor}
      >
        {state.snackbarMessage}
      </MuiAlert>
    </Snackbar>
  );
}

export default AlertSnackbar;
